import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table,
  TableBody,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';

import { deleteUser } from '../../actions/userActions';
import UserChangePassword from './UserChangePassword';
import ActivateUserToggle from './ActivateUserToggle';
import { text16 } from '../Styles/index';

const Warning = styled.div`
  background-color: rgba(244, 67, 54,.25);
  padding: 16px;
  color: #C62828;
  border-radius: 4px;
  margin-bottom: 24px
`
const ChangePasswordDialog = props => (
  <Dialog
    title={`Change password`}
    actions={props.actions}
    modal={true}
    open={props.open}
    onRequestClose={props.handleClose}
  >
    <UserChangePassword closeDialog={props.handleClose} user={props.user}/>
  </Dialog>
)

const DeleteDialog = (props) => (
  <Dialog
    title="Delete Account"
    actions={props.actions}
    modal={false}
    open={props.open}
    onRequestClose={props.handleClose}
  >
    <Warning>
      After you delete an account, it's permanently deleted. Accounts can't be undeleted.
    </Warning>
    <div style={{paddingLeft: '16px'}}>
      User Account: {props.email}
    </div>
  </Dialog>
)


class UsersTable extends Component {
  state = {
    stripedRows: false,
    showRowHover: false,
    selectable: false,
    multiSelectable: false,
    enableSelectAll: false,
    deselectOnClickaway: true,
    showCheckboxes: false,
    height: `${56 + this.props.height}px`,

    openDialog: false,
    openPasswordDialog: false,
    userToDelete: {},
    userToChangePassword: {}
  }

  _handleDialogCloseRequest = event => {
    this.setState({
      openDialog: false,
      userToDelete: {}
    })
  }

  _handlePasswordDialogCloseRequest = event => {
    this.setState({
      openPasswordDialog: false,
      userToChangePassword: {}
    })
  }

  _handleDialogOpenRequest = (event, account) => {
    this.setState({
      openDialog: true,
      userToDelete: account
    })
  }

  _handlePasswordDialogOpenRequest = (event, account) => {
    this.setState({
      openPasswordDialog: true,
      userToChangePassword: account
    })
  }

  _handleDeleteAccount = event => {
    event.preventDefault();
    console.log("submited");
    this.props.deleteUser({username: this.state.userToDelete.username})
      .then(_ => {
        if (this.props.user.status === 'deleted') {
          this.props.refreshPage();
        }
        this.setState({
          openDialog: false,
        })
      })
  }

  _dialogActions(){
    return [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={this._handleDialogCloseRequest}
      />,
      <form style={{display: 'inline-block'}} onSubmit={this._handleDeleteAccount}>
        <RaisedButton
          label="Delete"
          type="submit"
          backgroundColor="#F44336"
          labelStyle={{ color: 'white' }}
        />
      </form>,
    ]
  }

  render() {
    return (
      <div style={{minWidth: "1200px"}}>
        <Table
          style={{tableLayout: 'auto', minWidth: '100%'}}
          bodyStyle= {{ overflowX: undefined, overflowY: undefined }}
          height={this.state.height}
          selectable={this.state.selectable}
          multiSelectable={this.state.multiSelectable}
        >
          <TableBody
            displayRowCheckbox={this.state.showCheckboxes}
            deselectOnClickaway={this.state.deselectOnClickaway}
            showRowHover={this.state.showRowHover}
            stripedRows={this.state.stripedRows}
          >
            <TableRow>
              {this.props.headers.map((header, index) => {
                // if(index === this.props.headers.length - 1){
                //   return <TableHeaderColumn key={index}} tooltip={header}>{header}</TableHeaderColumn>
                // }
                return <TableHeaderColumn key={index} tooltip={header}>{header}</TableHeaderColumn>
              })}
            </TableRow>
            {this.props.tableData.map( (row, index) => (
              <TableRow key={index}>
                <TableRowColumn style={text16}>{row.no}</TableRowColumn>
                <TableRowColumn style={text16}>{row.name}</TableRowColumn>
                <TableRowColumn style={text16}>{row.username}</TableRowColumn>
                <TableRowColumn style={text16}>{row.email}</TableRowColumn>
                <TableRowColumn style={{padding: '0 8px', textAlign: 'right'}}>
                  <RaisedButton label="Orders" labelStyle={{height: 'auto'}} onTouchTap={(event) => this.props.gotToOrdersPage(row.username)} />
                  <span style={{width: '8px', display: 'inline-block'}}></span>
                  <RaisedButton label="Edit" labelStyle={{height: 'auto', color: 'white'}} backgroundColor="#4CAF50" onTouchTap={(event) => this.props.editHandler(row.username)}/>
                  <span style={{width: '8px', display: 'inline-block'}}></span>
                  <RaisedButton label="Delete" labelStyle={{height: 'auto', color: 'white'}} backgroundColor="#F44336" onTouchTap={event => this._handleDialogOpenRequest(event, row)} />
                  <span style={{width: '8px',display: 'inline-block'}}></span>
                  <ActivateUserToggle key={row.no} active={row.active} user={row}/>
                  <span style={{width: '8px',display: 'inline-block'}}></span>
                  <RaisedButton label="Change Password" labelStyle={{height: 'auto'}} onTouchTap={event => this._handlePasswordDialogOpenRequest(event, row)}/>
                  <span style={{width: '8px',display: 'inline-block'}}></span>
                </TableRowColumn> 
              </TableRow>
              ))}
          </TableBody>
        </Table>
        <div>
          <DeleteDialog
            open={this.state.openDialog}
            actions={this._dialogActions()}
            handleClose={this._handleDialogCloseRequest}
            email={this.state.userToDelete.email}></DeleteDialog>
          <ChangePasswordDialog
            open={this.state.openPasswordDialog}
            actions={[]}
            handleClose={this._handlePasswordDialogCloseRequest}
            user={this.state.userToChangePassword}
          />
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => ({ user: state.user.deleted });
const mapDispatchToProps = { deleteUser };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UsersTable));



// WEBPACK FOOTER //
// ./src/components/Users/UsersTable.js